import { CATEGORIES, LOCATIONS, sendEvent } from 'tracking';

export const metrics = {
  downloadDocx: () =>
    sendEvent('Download Word', {
      Location: LOCATIONS.fullProfile,
      Category: CATEGORIES.fullProfile,
      Contact_Opens_Count: 1,
    }),
  downloadPdf: () =>
    sendEvent('Download PDF', {
      Location: LOCATIONS.fullProfile,
      Category: CATEGORIES.fullProfile,
      Contact_Opens_Count: 1,
    }),
};
